import TransferDestination from "manifest-components/src/classes/transferDestination";
import TransferSource from "manifest-components/src/classes/transferSource";
import Transfer from "manifest-components/src/classes/transfer";
import TransferInstruction from "manifest-components/src/classes/transferInstruction";
import TransferOptions from "manifest-components/src/classes/transferOptions";

export enum Actions {
  FETCHING_CANCELLED_TRANSFERS = "FETCHING_CANCELLED_TRANSFERS",
  FETCHING_COMPLETE_TRANSFERS = "FETCHING_COMPLETE_TRANSFERS",
  FETCHING_CURRENT_TRANSFER = "FETCHING_CURRENT_TRANSFER",
  FETCHING_INITIATED_TRANSFERS = "FETCHING_INITIATED_TRANSFERS",
  FETCHING_QUEUED_TRANSFERS = "FETCHING_QUEUED_TRANSFERS",
  FETCHING_IN_PROGRESS_TRANSFERS = "FETCHING_IN_PROGRESS_TRANSFERS",
  FETCHING_PROVIDERS_LIST = "FETCHING_PROVIDERS_LIST",
  FETCHING_TRANSFER = "FETCHING_TRANSFER",
  FETCHING_TRANSFER_DESTINATION = "FETCHING_TRANSFER_DESTINATION",
  FETCHING_TRANSFER_INSTRUCTIONS_WITH_USER_INPUT_NEEDED = "FETCHING_TRANSFER_INSTRUCTIONS_WITH_USER_INPUT_NEEDED",
  FETCHING_TRANSFER_OPTIONS = "FETCHING_TRANSFER_OPTIONS",
  FETCHING_TRANSFERRED_DESTINATIONS = "FETCHING_TRANSFERRED_DESTINATIONS",
  GET_CANCELLED_TRANSFERS = "GET_CANCELLED_TRANSFERS",
  GET_COMPLETE_TRANSFERS = "GET_COMPLETE_TRANSFERS",
  GET_INITIATED_TRANSFERS = "GET_INITIATED_TRANSFERS",
  GET_QUEUED_TRANSFERS = "GET_QUEUED_TRANSFERS",
  GET_IN_PROGRESS_TRANSFERS = "GET_IN_PROGRESS_TRANSFERS",
  GET_IRA_OPTIONS = "GET_IRA_OPTIONS",
  GET_PROVIDERS_LIST = "GET_PROVIDERS_LIST",
  GET_ROTH_TRANSFERRED_DESTINATIONS = "GET_ROTH_TRANSFERRED_DESTINATIONS",
  GET_TRANSFER_INSTRUCTIONS_WITH_USER_INPUT_NEEDED = "GET_TRANSFER_INSTRUCTIONS_WITH_USER_INPUT_NEEDED",
  GET_TRANSFER_OPTIONS = "GET_TRANSFER_OPTIONS",
  GET_TRANSFERRED_DESTINATIONS = "GET_TRANSFERRED_DESTINATIONS",
  INITIATE_NEW_TRANSFER = "INITIATE_NEW_TRANSFER",
  CONNECT_DESTINATION_TO_TRANSFER = "CONNECT_DESTINATION_TO_TRANSFER",
  REMOVE_DATA = "REMOVE_DATA",
  REMOVE_TRANSFER = "REMOVE_TRANSFER",
  SET_CURRENT_TRANSFER = "SET_CURRENT_TRANSFER",
  SET_LOADING = "SET_LOADING",
  SHOW_CURRENT_TRANSFER = "SHOW_CURRENT_TRANSFER",
  SHOW_ALL_TRANSFERS = "SHOW_ALL_TRANSFERS",
  UPDATE_TRANSFER_DESTINATION = "UPDATE_TRANSFER_DESTINATION",
  UPDATING_TRANSFER_DESTINATION = "UPDATING_TRANSFER_DESTINATION",
  UPDATE_TRANSFER_SOURCE = "UPDATE_TRANSFER_SOURCE",
  UPDATING_TRANSFER_SOURCE = "UPDATING_TRANSFER_SOURCE",
  UPDATE_TRANSFER_ID = "UPDATE_TRANSFER_ID",
  FETCHING_WAIT_FOR_IRA_TRANSFER = "FETCHING_WAIT_FOR_IRA_TRANSFER",
  GET_WAIT_FOR_IRA_TRANSFER = "GET_WAIT_FOR_IRA_TRANSFER",
}

export type Action =
  | { type: Actions.FETCHING_CANCELLED_TRANSFERS }
  | { type: Actions.FETCHING_COMPLETE_TRANSFERS }
  | { type: Actions.FETCHING_CURRENT_TRANSFER }
  | { type: Actions.FETCHING_INITIATED_TRANSFERS }
  | { type: Actions.FETCHING_QUEUED_TRANSFERS }
  | { type: Actions.FETCHING_WAIT_FOR_IRA_TRANSFER }
  | { type: Actions.FETCHING_IN_PROGRESS_TRANSFERS }
  | { type: Actions.FETCHING_PROVIDERS_LIST }
  | { type: Actions.FETCHING_TRANSFER_DESTINATION; payload: boolean }
  | { type: Actions.FETCHING_TRANSFER_INSTRUCTIONS_WITH_USER_INPUT_NEEDED }
  | { type: Actions.FETCHING_TRANSFER_OPTIONS }
  | { type: Actions.FETCHING_TRANSFERRED_DESTINATIONS }
  | { type: Actions.GET_CANCELLED_TRANSFERS; payload: TransferInstruction[] }
  | { type: Actions.GET_COMPLETE_TRANSFERS; payload: TransferInstruction[] }
  | { type: Actions.GET_INITIATED_TRANSFERS; payload: TransferInstruction[] }
  | { type: Actions.GET_QUEUED_TRANSFERS; payload: TransferInstruction[] }
  | { type: Actions.GET_IN_PROGRESS_TRANSFERS; payload: Transfer[] }
  | { type: Actions.GET_WAIT_FOR_IRA_TRANSFER; payload: TransferInstruction[] }
  | {
      type: Actions.GET_IRA_OPTIONS;
      payload: {
        accountOpeningUrl: string;
        body: {
          content: string;
          header: string;
        }[];
        iraProviderName: string;
        subtitle: string[];
        title: string;
      }[];
    }
  | {
      type: Actions.GET_PROVIDERS_LIST;
      payload: {
        label: string;
        value: string;
      }[];
    }
  | {
      type: Actions.GET_ROTH_TRANSFERRED_DESTINATIONS;
      payload: TransferDestination[];
    }
  | { type: Actions.GET_TRANSFER_INSTRUCTIONS_WITH_USER_INPUT_NEEDED; payload: TransferInstruction[] }
  | { type: Actions.GET_TRANSFER_OPTIONS; payload: TransferOptions }
  | {
      type: Actions.GET_TRANSFERRED_DESTINATIONS;
      payload: TransferDestination[];
    }
  | { type: Actions.INITIATE_NEW_TRANSFER; payload: Transfer }
  | { type: Actions.CONNECT_DESTINATION_TO_TRANSFER }
  | { type: Actions.REMOVE_DATA }
  | { type: Actions.REMOVE_TRANSFER }
  | {
      type: Actions.SET_CURRENT_TRANSFER;
      payload: { transferIdReceived?: number; data: Transfer };
    }
  | { type: Actions.SET_LOADING; payload: boolean }
  | { type: Actions.SHOW_ALL_TRANSFERS }
  | { type: Actions.SHOW_CURRENT_TRANSFER }
  | { type: Actions.UPDATE_TRANSFER_DESTINATION; payload: TransferDestination }
  | { type: Actions.UPDATE_TRANSFER_SOURCE; payload: TransferSource[] }
  | { type: Actions.UPDATING_TRANSFER_DESTINATION; payload: boolean }
  | { type: Actions.UPDATE_TRANSFER_ID; payload: string }
  | { type: Actions.UPDATING_TRANSFER_SOURCE; payload: boolean };
